import { defineMessages } from "react-intl"

export default defineMessages({
    headerToolsSoftware: {
        id: "app.components.ToolsSofware.headerToolsSoftware"
    },
    toolsSoftwareTesting: {
        id: "app.components.ToolsSoftware.toolsSoftwareTesting"
    },
    toolsSoftwares: {
        id: "app.components.ToolsSoftware.toolsSoftwares"
    },
    "toolsSoftwares.UbisoftConnect": {
    id: "app.components.ToolsSoftware.UbisoftConnect",
    },
    "toolsSoftwares.R6Marketplate": {
    id: "app.components.ToolsSoftware.R6Marketplate",
    },
});
